import { render, staticRenderFns } from "./icon_mdi_information_variant.vue?vue&type=template&id=a1c6c068"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports